<template>
  <div id="page-wrap" v-if="loggedIn" class="plan">
    <PlanCategoryHeader />
    <section>
      <div class="offers">
        <OfferItem v-for="(plan, index) in filteredPlans" :key="index" :plan="plan" />
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import OfferItem from "./OfferItem/index";
import PlanCategoryHeader from "./PlanCategoryHeader/index";
export default {
  name: "plan",
  data() {
    return {
      query: {},
      selected_mode: "",
      txnAmount: 0,
      operatorsLoaded: false,
      paymentMethod: [
        { displayName: "Prepaid", methodKey: "prepaid" },
        { displayName: "Postpaid", methodKey: "postpaid" }
      ]
    };
  },
  components: { OfferItem, PlanCategoryHeader },
  computed: {
    ...mapGetters([
      "loggedIn",
      "planCategories",
      "filteredPlans",
      "selectedCategory"
    ])
  },
  mounted() {
    this.$store.dispatch("filterPlans", this.selectedCategory);
  },
  methods: {
    proceedToPayment() {}
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Plan.vue